import SSEConstant from '../const/SSEConstant'
import {isnull} from '../../utils/tools'
import {loge, log} from '../../utils/devext'
import EventBusConstant from '../const/EventBusConstant'
import global from '../../config/global'

export default class SSEMBListener {
  constructor(vueObj) {
    this.pageTarget = vueObj
  }

  onReceivePush(pushRsp) {
    switch (pushRsp.subCode) {
      case SSEConstant.OpMulti.joinRoom :             // 加入房间
        this.onJoinRoom(pushRsp)
        break;
      case SSEConstant.OpMulti.leaveRoom :            // 离开房间

        break;
      case SSEConstant.OpMulti.sendGift :             // 用户送礼

        break;
      case SSEConstant.OpMulti.applyToBeBoss :        // 用户申请当boss
        this.onApplyToBeBoss(pushRsp)
        break;
      case SSEConstant.OpMulti.bossPutOffMic :        // 老板下麦

        break;
      case SSEConstant.OpMulti.userTakeAnchor :       // 用户带走主播
        this.onTakeAnchor(pushRsp)
        break;
      case SSEConstant.OpMulti.bossBilling :          // 老板计费
        this.onBossBilling(pushRsp)
        break;
      case SSEConstant.OpMulti.remindBossToRecharge : // 提醒老板充值
        this.onRemindBossRecharge(pushRsp)
        break;
      case SSEConstant.OpMulti.sendTextMsg :          // 发送文字消息

        break;
      case SSEConstant.OpMulti.memberCloseMic :       //

        break;
      case SSEConstant.OpMulti.memberOpenMic :        //

        break;
      case SSEConstant.OpMulti.getRoomInfo :          // 获取房间信息

        break;
      case SSEConstant.OpMulti.clientDisconnect :     // clientDisconnect

        break;
    }
  }

  /**
   * 加入房间
   */
  onJoinRoom(pushRsp) {
    log('onJoinRoom', "收到 onJoinRoom " + pushRsp)
    if (!isnull(pushRsp.data)) {
      try {
        let LiMeMultiData = pushRsp.data
        this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_MULTI_JOIN_ROOM, pushRsp.retCode, LiMeMultiData)
      } catch (e) {
        loge('onJoinRoom', e.toString())
      }
    }
  }

  /**
   * 用户申请当boss
   */
  onApplyToBeBoss(pushRsp) {
    log('onApplyToBeBoss', "收到 onApplyToBeBoss " + pushRsp)
    this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_APPLY_TO_BE_BOSS, pushRsp.retCode)


  }

  /**
   * 用户带走主播
   */
  onTakeAnchor(pushRsp) {

    log('onTakeAnchor', "收到 onTakeAnchor " + pushRsp)
    let PP_EnterPriChaData = null
    if (!isnull(pushRsp.data)) {
      try {
        PP_EnterPriChaData = pushRsp.data
      } catch (e) {
        loge('onTakeAnchor', e.toString())
      }
    }
    this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_MULTI_TAKE_ANCHOR, pushRsp.retCode, PP_EnterPriChaData)
  }

  /**
   * 老板计费
   */
  onBossBilling(pushRsp) {
    log('onBossBilling', "收到 onBossBilling " + pushRsp)
    let LiMeMultiBossBillingMsg = null
    if (!isnull(pushRsp.data)) {
      try {
        LiMeMultiBossBillingMsg = pushRsp.data
      } catch (e) {
        loge('onBossBilling', e.toString())
      }
    }
    this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_BOSS_BILLING, pushRsp.retCode, LiMeMultiBossBillingMsg)

  }

  /**
   * 提醒老板充值
   */
  onRemindBossRecharge(pushRsp) {
    log('onRemindBossRecharge', "收到 onRemindBossRecharge ${pushRsp.retCode}")
    this.pageTarget.$EventBus.$emit(EventBusConstant.EVENT_REMIND_BOSS_RECHARGE, pushRsp.retCode)
  }


}



// WEBPACK FOOTER //
// ./src/push/listener/SSEMBListener.js